<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyazarfteslim from "@/models/satdosyazarfteslim";



export default {
  mixins: [apibtoast, apigeneric, satdosyazarfteslim],
  props: ["Id", "AddEdit", "satdosyaId"],
  data() {
    return {
      FormData: {},
      personelunvani:"",
      KurumBilgisi :[],
      ihaleilani : [],
      Dosya:{},
          Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader, 

 
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Dosyaid = this.satdosyaId;
     
    },
  },
    created(){
    this.Get();
  },
  methods: {

    Get() {
      this.FormData = this.Id;
          this.ActionsGet({"Service":"OKurumSabit", "Page":this.Page}).then((res) => {

        this.KurumBilgisi = res.Data[0];

      });

        this.ActionsGet({"Service":"SatDosya/"+this.satdosyaId, "Page":this.Page}).then((res) => {
    
        this.Dosya = res.Data;
   

      });

            this.ActionsFilterGet({"Service":"SatDosyaIhaleIlani", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
          this.ihaleilani=res.Data;

      });

      
            this.ActionsGet({"Service":"OPersonel/"+this.FormData.Personelid, "Page":this.Page}).then((res2) => {
             
               this.personelunvani=res2.Data.Unvanadi;

            });

    }, 
            
Export2Word(element, filename = 'Zarf Alındı Belgesi'){
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
   },

     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="zarfalindibelgesi"
      size="lg"
      :title="$t('satdosyazarfteslim.AlindiBelgesi.Title')"
      title-class="font-18"
      hide-footer
    >  

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
     
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent')" 
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Word'e Aktar
                    </button>
                  </div>
                </div>
              </div>


          <div id="exportContent"> 
    
            <div class="a4_dikey">
            <div style=" margin: 10px" class="table-responsive">
                      <table  style="width:90%; margin-left: 10px; margin-right: 5px;" class="table mb-2">
                        <tr>
                          <td colspan="3"><center><h4> {{KurumBilgisi.Kurumadi}}</h4></center> </td>
                        </tr>
                        <tr>
                          <th>İhale kayıt numarası</th><td width="10">:</td><td>{{ihaleilani[0].Ihalekayitnumarasi}}</td>
                        </tr>
                        <tr>
                          <th>İdarenin adı</th><td width="10">:</td><td></td>
                        </tr>
                        <tr>
                          <th>İşin adı</th><td width="10">:</td><td>{{Dosya.Dosyaadi}}</td>
                        </tr>
                        <tr>
                          <th>İhale tarih ve saati</th><td width="10">:</td><td> {{ihaleilani[0].Ihaletarihsaati | formatDateTime}} </td>
                        </tr>
                        <tr>
                          <th style="width:40%">İhale teklif zarfının [verildiği/postadan alındığı] tarih ve saat</th>
                          <td width="10">:</td><td> {{FormData.Teslimtarihsaat | formatDateTime }} </td>
                        </tr>
                        <tr>
                          <th style="width:40%">Sıra No</th><td width="10">:</td><td>{{FormData.Sirano}} </td>
                        </tr>
                        

                      </table>
            </div>
            <br> <br> <br> <br> <br> 

            <div><center><h5> {{$t("satdosyazarfteslim.AlindiBelgesi.metinbaslik")}}</h5></center></div>
            <br>
            <div style="margin-left: 20px;"  >
              <span >
              {{FormData.Firmaadi}}’ na ait ihale teklif zarfı, yukarıda belirtilen sıra numarası ile teslim alınmıştır.
              </span>
            </div>

            <br><br><br>
            <div> 

              <table>
              <tr><td width="500"></td><td><center>Teslim Alan İdare Yetkilisi</center></td></tr>
              <tr><td width="500"></td><td><center>{{FormData.Adsoyad}}</center> </td></tr>
              <tr><td width="500"></td><td><center>{{personelunvani}}</center></td></tr>
              </table>
                     

            </div>
   <br>
   <br>
    

              <footer> 
              {{$t("satdosyazarfteslim.AlindiBelgesi.KikFormKodu")}}<br>
              {{$t("satdosyazarfteslim.AlindiBelgesi.KikFormAdi")}}

            </footer>

            </div>
          </div>



    </b-modal>
  </Loader>
</template>

<style>

 .a4_dikey {

	width: 20.5cm;
	height: 29cm;
	position: relative;
}
.a4_dikey footer {
	position: absolute;
	bottom: 10px;
	right: 25px;
}

.yazi{

   font-family: Arial, Helvetica, sans-serif;
   font-size: 12px; 
   line-height: 15px;
   
}
    
</style>